import React from 'react';
import BaseComponent from './BaseComponent';

class MainView extends BaseComponent {
  constructor(props) {
    super(props)
    this.state = { 
      screen: { width: window.innerWidth, height: window.innerHeight},
      heroHeight: window.innerHeight, 
      menu: false,
      scrolled: false
    }
    this._bind('updateWindowDimensions', 'toggleMenu', 'handleScroll')
  }

  componentDidMount() {
    window.addEventListener('resize', this.updateWindowDimensions);
    window.addEventListener('scroll', this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
    window.removeEventListener('scroll', this.handleScroll);
  }

  updateWindowDimensions() {
    this.setState({screen: { width: window.innerWidth, height: window.innerHeight }});
  }

  handleScroll(e) {
    if ( window.scrollY > 200 && this.state.scrolled === false) {
      this.setState({ scrolled : true })
    } else if ( window.scrollY <= 200 && this.state.scrolled === true) {
      this.setState({ scrolled : false })
    }
  }

  scrollTo(section, e) {
    e.preventDefault();
    let position = 0;
    let offset = this.state.screen.width < 720 ? 0 : 70;
    switch(section) {
      case 'how_to':
        position = this.refs.how_to.offsetTop - offset;
        break;
      case 'about':
        position = this.refs.about.offsetTop - offset;
        break;
      case 'about_ar':
        position = this.refs.about_ar.offsetTop - offset;
        break;
      case 'download':
        position = this.refs.download.offsetTop - offset;
        break;
      default:
        break;
    }

    window.scrollTo(0, position);
    if (this.state.menu) {
      this.toggleMenu()
    }
  }

  toggleMenu() {
    if ( this.state.menu ) {
      this.setState({ menu: false })
    } else {
      this.setState({ menu: true })
    }
  }

  render() {
    let menu_cl = "menu";
    if ( this.state.menu ) {
      menu_cl += " active"
    }
    if ( this.state.scrolled ) {
      menu_cl += " scrolled"
    }

    let policyFooter = ""
    if ( this.state.screen.width >= 720 ) {
      policyFooter = <a href={ this.props.data.page.privacy_link } target="_blank">{ this.props.data.page.privacy }</a>
    }
    return (
      <div className={"lp-app "+this.props.lang}>
        <div className={ this.state.scrolled ? "nav-trigger scrolled" : "nav-trigger" } onClick={ this.toggleMenu }><span className="line"></span></div>
        <div className={ menu_cl } style={this.state.screen.width < 720 ? { height: this.state.screen.height+'px' } : {}}>
          <nav>
            <ul>
              <li><a href="#download" onClick={ this.scrollTo.bind(this, 'download') }>{this.props.data.page.nav.download}</a></li>
              <li><a href="#jak-to-dziala" onClick={ this.scrollTo.bind(this, 'how_to') }>{this.props.data.page.nav.how}</a></li>
              <li><a href="#info" onClick={ this.scrollTo.bind(this, 'about') }>{this.props.data.page.nav.info}</a></li>
              <li><a href={this.props.lang === "en" ? process.env.PUBLIC_URL+"/" : process.env.PUBLIC_URL+"/en"} >{this.props.data.page.nav.lang}</a></li>
              { this.state.screen.width < 720 ? <li><a href={ this.props.data.page.privacy_link} target="_blank">{this.props.data.page.privacy}</a></li> : null }
            </ul>
            { this.state.screen.width < 720 ?
              <div className="social">
                <a href={ this.props.data.page.fb_link } target="_blank"><img alt="Facebook" src={process.env.PUBLIC_URL+"/images/fb-white.png"} /></a>
                <a href={ this.props.data.page.ig_link } target="_blank"><img alt="Instagram" src={process.env.PUBLIC_URL+"/images/ig-white.png"} /></a>
              </div> : null }
          </nav>
        </div>
        <section className="hero" style={this.state.screen.width < 720 && this.state.heroHeight > 600 ? { height: this.state.heroHeight+'px' } : {}}>
          <div className="inner">
            <a href="/" className="logo"><img alt="Logo Szlak Piastowski" src={process.env.PUBLIC_URL+"/images/logo.png"} /></a>
            <div className="eu-logo"><img alt="EU" src={process.env.PUBLIC_URL+"/images/eu_"+this.props.lang+".png"} /></div>
            <h1>{ this.props.data.hero.title }</h1>
            <p className="hero-text" dangerouslySetInnerHTML={{ __html: this.props.data.hero.text }}></p>
            <p className="get-ar">{ this.props.data.hero.get_ar }</p>
            <div className="store-buttons" ref="download">
              <a href={ this.props.data.hero.app_store_link } className="button app-store-btn" style={{ backgroundImage: 'url('+process.env.PUBLIC_URL+'/images/apple.png)' }}>{ this.props.data.hero.app_store_text }</a>
              <a href={ this.props.data.hero.play_store_link } className="button playstore-btn" style={{ backgroundImage: 'url('+process.env.PUBLIC_URL+'/images/play.png)' }}>{ this.props.data.hero.play_store_text }</a>
            </div>
          </div>
        </section>
        <section className="how-to" ref="how_to">
          <div className="inner">
            <h2 dangerouslySetInnerHTML={{ __html: this.props.data.how_to.title }}></h2>
            <ul className="steps">
              { this.props.data.how_to.steps.map((item, key) => {
                return (
                  <li key={ 'item-'+key }>
                    <span className="nr">{ key+1 }</span>
                    <h3 className="step-title" dangerouslySetInnerHTML={{ __html: item.title }}></h3>
                    <p className="step-text">{ item.text }</p>
                  </li>
                )
              })}
            </ul>
            <img alt="Mapa Szlaku Piastowskiego" src={process.env.PUBLIC_URL+"/images/mapa.png"} />
          </div>
        </section>
        <section className="about" ref="about">
          <div className="inner">
            <h2>{ this.props.data.about.title }</h2>
            <div className="paragraphs">
              { this.props.data.about.paragraphs.map((item, key) => {
                return (
                  <p key={ 'item-'+key }>
                    { item }
                  </p>
                )
              })}
            </div>
          </div>
        </section>
        <section className="about-ar" ref="about_ar">
          <div className="inner">
            <h2>{ this.props.data.about_ar.title }</h2>
            <div className="paragraphs">
              { this.props.data.about_ar.paragraphs.map((item, key) => {
                return (
                  <p key={ 'item-'+key }>
                    { item }
                  </p>
                )
              })}
            </div>
          </div>
        </section>
        <footer className="footer">
          <div className="inner">
            <p dangerouslySetInnerHTML={{ __html: this.props.data.footer.eu_text }}></p>
            <div className="eu-logos">
              <img className="eu-img" src={process.env.PUBLIC_URL+"/images/eu_funds_"+this.props.lang+".png"}/>
              <img className="eu-img" src={process.env.PUBLIC_URL+"/images/pl_flag_"+this.props.lang+".png"}/>
              <img className="eu-img" src={process.env.PUBLIC_URL+"/images/wlkp.png"}/>
              <img className="eu-img" src={process.env.PUBLIC_URL+"/images/eu_flag_"+this.props.lang+".png"}/>
              { this.state.screen.width >= 720 ?
                <div className="social">
                  <a href={ this.props.data.page.fb_link } target="_blank"><img alt="Facebook" src={process.env.PUBLIC_URL+"/images/fb-red.png"} /></a>
                  <a href={ this.props.data.page.ig_link } target="_blank"><img alt="Instagram" src={process.env.PUBLIC_URL+"/images/ig-red.png"} /></a>
                </div> : null }
            </div>
            <p className="copy"><span dangerouslySetInnerHTML={{ __html: this.props.data.footer.copy }}></span> { policyFooter }</p>
          </div>
        </footer>
      </div>
    );
  }
}

export default MainView;